import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

class PageTestContainer extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { t } = this.props
    return (
      <div className='py-4'>
        <div className='wrap-inner'>
          <p>MixR page Test</p>
        </div>
      </div>
    )
  }
}

const ExtendedComponent = withTranslation('common')(PageTestContainer)
export { ExtendedComponent as PageTestContainer }
